"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VerticalNavList = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _VerticalNavList = require("./VerticalNavList.styles");
/**
 * Acts as a wrapper for `VerticalNav.Item` components.
 *
 * @since 8.72.0
 */

var VerticalNavList = /*#__PURE__*/(0, _react.forwardRef)(function (props, forwardedRef) {
  return /*#__PURE__*/_react.default.createElement(_VerticalNavList.StyledVerticalNavList, (0, _extends2.default)({
    ref: forwardedRef
  }, props));
});
exports.VerticalNavList = VerticalNavList;
VerticalNavList.displayName = 'VerticalNavList';
VerticalNavList.propTypes = {
  /**
   * A group of `VerticalNav.Item` components.
   */
  children: _propTypes.default.node.isRequired,
  /**
   * Use the styled-components
   * [polymorphic "as" prop](https://www.styled-components.com/docs/api#as-polymorphic-prop)
   * to change the HTML tag of the component.
   *
   * This can be used to apply `Button` styling to HTML anchors, inputs, and custom components.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  as: _propTypes.default.any
};
VerticalNavList.defaultProps = {};